import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { AppBar, makeStyles, Modal, Tab, Tabs } from '@material-ui/core';
import axios from 'axios';
import MyButton from 'components/form/MyButton';
import MyRichModal from 'components/modal/MyRichModal';
import { callAxios, formatError } from 'components/utils/FormatData';
import { genKey, getStorage, setStorage } from 'components/utils/Storage';
import { SvgIcon } from 'components/utils/SvgIcon';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { ClipLoader } from 'react-spinners';
import { MAX_STORAGE_DETAIL_EQUIP, URL_API } from '../../constants/settings';
import useWindowSize from '../../hooks/useWindowSize';
import DisplayReturnCommand from './DisplayReturnCommand';
import OngletAlarme from './onglet/OngletAlarme';
import OngletDetail from './onglet/OngletDetail';
import OngletCommandes from './onglet/OngletCommandes';
import OngletOt from './onglet/OngletOt';
import SelectMotifAcquittement from './SelectMotifAcquittement';
import moment from 'moment';
import { distanceEnKm } from '../../components/utils/Position';
import { REMOVE_MESSAGE } from '../../constants/constants';


const useStyles = makeStyles({
  appBar: {
    backgroundColor: 'transparent',
    color: 'black',
    boxShadow: 'none',
    alignItems: 'center',
    '& .MuiTab-textColorInherit.Mui-selected': {
      color: '#0094CA',
      fontWeight: '600',
    },
  },
  tab: {
    fontSize: '14px',
  },
  tabPanel: {
    '& .MuiBox-root': {
      padding: '0px',
    },
  },
  cardContentCaracteristique: {
    padding: 6,
    '&:last-child': {
      paddingBottom: 9,
    },
  },
  cardAlarm: {
    marginBottom: '10px',
    boxShadow: '0px 0px 5px 0px rgb(0 0 0 / 20%)',
    display: 'flex',
    flexDirection: 'column',
    fontSize : '2.5vw'
  },
  cardOt: {
    padding: '3px 10px',
    marginBottom: '10px',
    boxShadow: '0px 0px 5px 0px rgb(0 0 0 / 20%)',
    display: 'flex',
    flexDirection: 'row',
    alignItems : 'center',
    fontSize : '2.5vw'
  },
  root: {
    padding: '0px',
  },
  appBarDesktop: {
    backgroundColor: 'transparent',
    color: 'black',
    boxShadow: 'none',
    alignItems: 'center',
    borderBottom: '1px solid #d6dad6',
    '& .MuiTab-textColorInherit.Mui-selected': {
      color: '#bb0060',
      fontWeight: '600',
    },
    '& .MuiButtonBase-root': {
      margin: '0 20px',
    },
  },
  tabDesktop: {
    fontSize: '1vw',
  },
});

const EquipmentDetail = (props) => {
  const alert = useAlert();
  const classes = useStyles();
  const params = useParams();
  const history = useHistory();
  const [width, height] = useWindowSize();
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const [componentHeight, setComponentHeight] = useState(height - 160);
  const [needUpdate, setNeedUpdate] = useState(false);
  const [acknowledgeAllAlarms, setAcknowledgeAllAlarms] = useState(false);
  const [openCommentOt, setOpenCommentOt] = useState(false);
  const [openLogCommand, setOpenLogCommand] = useState(false);
  const [logCommand, setLogCommand] = useState('');
  const [openResponseCommand, setOpenResponseCommand] = useState(false);
  const [responseCommand, setResponseCommand] = useState('');
  const [selectedOt, setSelectedOt] = useState();
  const [equipment, setEquipment] = useState();
  const [commandes, setCommandes] = useState([]);
  const [commandesReferences, setCommandesReferences] = useState([]);
  const [selectedCommand, setSelectedCommand] = useState(null);
  const [entryCommand, setEntryCommand] = useState('');
  const [sendingCommand, setSendingCommand] = useState(null);
  const [etats, setEtats] = useState([]);
  const [ots, setOts] = useState([]);
  const [btnSendCommandeIsLoading, setBtnSendCommandeIsLoading] = useState(false);
  const [btnDownloadMivisuLogIsLoading, setBtnDownloadMivisuLogIsLoading] = useState(false);
  const [btnAcknowledgeAlarmsIsLoading, setBtnAcknowledgeAlarmsIsLoading] = useState(false);
  const auth = useSelector(state => state["authentification"]);
  const storeWs = useSelector(state => state.websocket);
  const dispatch = useDispatch();

  useEffect(() => {
    setComponentHeight(height - 160);
  }, [width, height]);

  useEffect(() => {
    if (needUpdate) {
      fetchDetailEquipment();
      setNeedUpdate(false);
    }
  }, [needUpdate]);

  useEffect(() => {
    if (equipment?.famille) {
      fetchCommandesReferences();
    }
  }, [equipment]);

  useEffect(() => {
    if (props.wsStatus !== null) {
      fetchDetailEquipment();
      fetchCommandes();
      fetchEtatsEquipement();
      fetchHistoOts();
    }
  }, [props.wsStatus]);

  // Push Websocket - Refresh du composant
  useEffect(() => {
    if (equipment && storeWs.count && storeWs.count > 0) {
      for (const aMsgWs of storeWs.messages) {
        // Boucle sur l'ensemble des messages du websocket
        const type = aMsgWs['Type'];
        const message = aMsgWs['Payload'];
        let action = "NOTHING";
        let objet = "INCONNU";
        // Modification de la liste des commandes de l'équipement
        if (type.startsWith("sed.COMMANDE")) {
          objet = "COMMANDE";
          let commandsUpdated = [...commandes];
          if (message) {
            const commandIndex = commandsUpdated.findIndex((e) => e.id === message['id']);
            // Gestion de refresh du composant
            switch (type) {
              case "sed.COMMANDE.create":
              case "sed.COMMANDE.update":
                if (message.equipement.id === equipment.id) {
                  if (commandIndex > -1) {
                    action = "UPDATE";
                    commandsUpdated[commandIndex] = message;
                    const tabEtatTermine = ['REPONDUE', 'TERMINEE', 'EN_ERREUR'];
                    if (tabEtatTermine.includes(message.etat)) {
                      setOpenLogCommand(false);
                    }
                  } else {
                    action = "ADD";
                    commandsUpdated.unshift(message);
                  }
                } else {
                  if (commandIndex > -1) {
                    action = "REMOVE";
                    commandsUpdated.splice(commandIndex, 1);
                  }
                }
                if (sendingCommand && sendingCommand.id === message.id) {
                  setSendingCommand(message);
                  setLogCommand(message.log);
                }
                break;
              case "sed.COMMANDE.delete":
                if (commandIndex > -1) {
                  action = "REMOVE";
                  commandsUpdated.splice(commandIndex, 1);
                }
                break;
            }
          }
          setCommandes(commandsUpdated);
        }
        // Modification de l'équipement
        else if (type.startsWith("sed.EQUIPEMENT")) {
          objet = "EQUIPEMENT";
          switch (type) {
            case "sed.EQUIPEMENT.create":
              // do nothing
              break;
            case "sed.EQUIPEMENT.update":
              let equipmentToUpdate = JSON.parse(JSON.stringify(equipment));
              if (equipmentToUpdate.id === aMsgWs['Payload']['id']) {
                action = "UPDATE";
                equipmentToUpdate = aMsgWs['Payload'];
                console.log('Mise à jour de l\'équipement ' + equipment.idSociete);
                setEquipment(equipmentToUpdate);
                updateCacheDetailEquipment(equipmentToUpdate, "detail_equipment");
              }
              break;
            case "sed.EQUIPEMENT.delete":
              action = "DELETE";
              handleOnClose("");
              break;
          }
        }
        // TODO: Log à décommenter pour vérifier le bon fonctionnement du refresh
        console.log(`${objet} > ${action} > ${message.id}`);
        // Suppression du message du store
        dispatch({ type: REMOVE_MESSAGE, payload: message.id });
      }
    }
  }, [storeWs]);

  const fetchDetailEquipment = () => {
    callAxios(props.wsStatus, "detail_equipment", { method: 'get', url: `${URL_API}/equipements/${params.id}` }, null, alert)
      .then((res) => {
        if (props.wsStatus) {
          setEquipment(res);
          updateCacheDetailEquipment(res, "detail_equipment");
        } else {
          const localStorage = res.find((d) => d.id === params.id);
          if (localStorage) setEquipment(localStorage.obj);
        }
      });
  };
  const fetchCommandes = () => {
    callAxios(props.wsStatus, "detail_commandes", { method: 'get', url: URL_API + '/commandes-directes/equipements/' + params.id }, null, alert)
      .then((res) => {
        if (props.wsStatus) {
          setCommandes(res);
          updateCacheDetailEquipment(res, "detail_commandes");
        } else {
          const localStorage = res.find((d) => d.id === params.id)
          if (localStorage) setCommandes(localStorage.obj);
        }
      });
  };
  const fetchCommandesReferences = () => {
    callAxios(props.wsStatus, "detail_commandes_references", { method: 'get', url: URL_API + '/commandes-references', params: { famille: equipment.famille } }, null, alert)
      .then((res) => {
        if (props.wsStatus) {
          setCommandesReferences(res);
          updateCacheDetailEquipment(res, "detail_commandes_references");
        } else {
          const localStorage = res.find((d) => d.id === params.id)
          if (localStorage) setCommandesReferences(localStorage.obj);
        }
      });
  };
  const fetchEtatsEquipement = () => {
    callAxios(props.wsStatus, "detail_etats", { method: 'get', url: `${URL_API}/equipements/${params.id}/etats` }, null, alert)
      .then((res) => {
        if (props.wsStatus) {
          setEtats(res);
          updateCacheDetailEquipment(res, "detail_etats");
        } else {
          const localStorage = res.find((d) => d.id === params.id)
          if (localStorage) setEtats(localStorage.obj);
        }
      });
  };
  const fetchHistoOts = () => {
    callAxios(props.wsStatus, "detail_histo_ot", { method: 'get', url: `${URL_API}/equipements/${params.id}/ots` }, null, alert)
      .then((res) => {
        if (props.wsStatus) {
          setOts(res);
          updateCacheDetailEquipment(res, "detail_histo_ot");
        } else {
          const localStorage = res.find((d) => d.id === params.id)
          if (localStorage) setOts(localStorage.obj);
        }
      });
  };

  const handleOnClose = (reason) => {
    if (reason !== 'backdropClick') {
      history.push('/equipements');
    }
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };
  const generateCardAlarmes = (alarm) => {
    let style = { borderLeft: '10px solid #e74c3c' };
    if (alarm.acquitEtat) {
      style = { borderLeft: '10px solid #f18d2d' };
    }
    return style;
  };
  const generateCardOt = (anOt) => {
    if (anOt.systemStatus === 0) {
      return (<div className="pastille-system-status" style={{ backgroundColor: '#e74c3c' }}>{anOt.systemStatus}</div>);
    } else if (anOt.systemStatus === 1) {
      return (<div className="pastille-system-status" style={{ backgroundColor: '#f18d2d' }}>{anOt.systemStatus}</div>);
    } else if (anOt.systemStatus >= 2) {
      return (<div className="pastille-system-status" style={{ backgroundColor: '#a5c946' }}>{anOt.systemStatus}</div>);
    }
  };
  const handleOpenCommentOt = (ot) => {
    console.log("Ouvrir Commentaire OT");
    setSelectedOt(ot);
    setOpenCommentOt(true);
  };
  const handleCreateOt = () => {
    axios({ method: 'get', url: `${URL_API}/equipements/${equipment.id}` })
    .then((res) => {
      history.push(`/equipement/ot/creation/${res.data.id}`, { equipment: res.data  });
    })
    .catch((err) => {
      alert.error(`Erreur lors de la récupération des informations de l'équipement [${equipment.id}]`);
    });
  };
  const handleSendCommande = () => {
    let command;
    // Désactivation du bouton
    setBtnSendCommandeIsLoading(true);
    // Préparation de la commande
    if (selectedCommand?.commande) {
      command = selectedCommand.commande;
    } else if (entryCommand) {
      command = entryCommand;
    } else {
      alert.error('Veuillez sélectionner et/ou renseigner une commande avant de continuer');
      setBtnSendCommandeIsLoading(false);
      return;
    }
    // Envoi de la commande
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append('commande', command);
    axios.post(URL_API + '/commandes-directes/equipements/' + equipment.id + '/envoyer', urlSearchParams)
      .then(function (res) {
        setSendingCommand(res.data);
        setLogCommand(res.data.log);
        setOpenLogCommand(true);
        setBtnSendCommandeIsLoading(false);
      })
      .catch(function (err) {
        formatError(alert, err);
        setBtnSendCommandeIsLoading(false);
      });
  };

  const handleOpenLogCommand = (commande) => {
    setLogCommand(commande.log);
    setOpenLogCommand(true);
  }

  const handleOpenResponseCommand = (commande) => {
    setResponseCommand(commande.reponse);
    setOpenResponseCommand(true);
  }

  const updateCacheDetailEquipment = (newObj, key) => {
    if (newObj && key) {
      const localStorage = getStorage(genKey(key));

      // Recherche dans le localStorage 
      if (localStorage) {
        const searchInStorage = localStorage.find((d) => d.id === params.id);

        // Si l'équipement existe, on le modifie
        if (searchInStorage && searchInStorage !== undefined) {
          const datasUpdated = [];

          localStorage.map((d) => {
            if (d.id === params.id) {
              datasUpdated.push({ id: params.id, obj: newObj });
            } else {
              datasUpdated.push(d);
            }
          });

          setStorage(genKey(key), datasUpdated);

        } else if (localStorage.length < MAX_STORAGE_DETAIL_EQUIP) { // Création de l'équipement s'il n'existe pas et qu'il reste de la place
          const nbValues = localStorage.push({ id: params.id, obj: newObj });
          setStorage(genKey(key), localStorage);

        } else if (localStorage.length >= MAX_STORAGE_DETAIL_EQUIP) { // Suppression du premier équipement de la liste pour ajouter le nouvel équipement
          const datasWithPlace = localStorage.slice(1, MAX_STORAGE_DETAIL_EQUIP);
          const nbValues = datasWithPlace.push({ id: params.id, obj: newObj });
          setStorage(genKey(key), datasWithPlace);
        }

      } else { // Création du localStorage
        setStorage(genKey(key), [{ id: params.id, obj: newObj }]);
      }
    }
  }

  const handleDownloadLogMivisu = (date) => {
    // Désactivation du bouton
    setBtnDownloadMivisuLogIsLoading(true);
    const nomFichier = equipment.mivisuIdInt + '__' + moment(date).format('DD-MM-YYYY') + '.csv';
    axios({
      method: 'get',
      url: URL_API + '/equipements/' + equipment.id + '/mivisu/log',
      params: { jour: date.format('YYYY-MM-DD') },
      responseType: 'blob'
    })
      .then((response) => {
        const donnees = new Blob([response.data]);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
          window.navigator.msSaveOrOpenBlob(donnees, nomFichier);
        } else {
          const url = window.URL.createObjectURL(donnees);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', nomFichier); //or any other extension
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href);
          link.remove();
        }
        setBtnDownloadMivisuLogIsLoading(false);
      })
      .catch(function (err) {
        formatError(alert, err);
        setBtnDownloadMivisuLogIsLoading(false);
      });
  }

  if (isMobile) {
    return (
      <div id="equipments" className='panel-contenu-mobile-tablette' style={{ height: height - 60 }}>
        {
          equipment &&
          <div className="header-detail-equipment-mobile">
            <div className="row" style={{ margin: '0' }}>
              <SvgIcon color={'#89a63a'} name={'signal-stream'} size={'100px'} type={equipment.famille} style={{ marginLeft: '15px' }} />
              <div className="row-column">
                <span className="main-title">{equipment ? equipment.toponyme : ''}</span>
                <span className="second-title">{equipment ? equipment.idSociete : ''}</span>
              </div>
            </div>

            <div className="row" style={{ margin: '0' }}>
              <AppBar position="static" className={classes.appBar}>
                <Tabs value={value} onChange={handleChange}>
                  <Tab label="Détail" {...a11yProps(0)} />
                  <Tab label="Commandes" {...a11yProps(1)} disabled={equipment.pilotable ? false : true} />
                  <Tab label="Histo. alarmes" {...a11yProps(2)} />
                  <Tab label="Histo. OT" {...a11yProps(3)} />
                </Tabs>
              </AppBar>
            </div>
          </div>
        }

        {
          equipment &&
          <div className='composant-content-center' style={{ height: componentHeight, overflow: 'auto', justifyContent: 'flex-start', flexDirection: 'column' }}>

            <OngletDetail
              width={width}
              value={value}
              equipment={equipment}
              auth={auth}
              classes={classes}
              setNeedUpdate={setNeedUpdate}
              handleOpenCommentOt={handleOpenCommentOt}
              handleCreateOt={handleCreateOt}
              setAcknowledgeAllAlarms={setAcknowledgeAllAlarms}
              acknowledgeAllAlarms={acknowledgeAllAlarms}
              btnDownloadMivisuLogIsLoading={btnDownloadMivisuLogIsLoading}
              handleDownloadLogMivisu={handleDownloadLogMivisu}
              generateCardOt={generateCardOt}
              generateCardAlarmes={generateCardAlarmes}
              wsStatus={props.wsStatus}
            />

            {
              equipment.pilotable &&
              <OngletCommandes
                value={value}
                width={width}
                classes={classes}
                auth={auth}
                setSelectedCommand={setSelectedCommand}
                entryCommand={entryCommand}
                setEntryCommand={setEntryCommand}
                commandesReferences={commandesReferences}
                handleSendCommande={handleSendCommande}
                btnSendCommandeIsLoading={btnSendCommandeIsLoading}
                handleOpenResponseCommand={handleOpenResponseCommand}
                handleOpenLogCommand={handleOpenLogCommand}
                commandes={commandes}
                wsStatus={props.wsStatus}
              />
            }

            <OngletAlarme
              width={width}
              value={value}
              equipment={equipment}
              classes={classes}
              etats={etats}
              auth={auth}
            />

            <OngletOt
              width={width}
              classes={classes}
              value={value}
              ots={ots}
              handleOpenCommentOt={handleOpenCommentOt}
              generateCardOt={generateCardOt}
              auth={auth}
              wsStatus={props.wsStatus}
            />

          </div>
        }

        {
          !equipment && !props.wsStatus &&
          <div className='composant-content-center' style={{ height: componentHeight, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
            <h2 style={{ margin: '10px' }}>L'affichage de l'équipement n'est pas possible car aucune donnée en cache n'a été trouvée</h2>
          </div>
        }
        {
          !equipment && props.wsStatus &&
          <div className='composant-content-center' style={{ height: componentHeight, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
            <ClipLoader
              color="#0094ca"
              loading={true}
              css={'display: flex; position: absolute; top: 45%; left:0; right:0; margin:auto; z-index:150; justify-content: center;'}
              size={50}
            />
          </div>
        }

        <SelectMotifAcquittement open={acknowledgeAllAlarms} setOpen={setAcknowledgeAllAlarms} entity={equipment} setNeedUpdate={setNeedUpdate}
         wsStatus={props.wsStatus} setBtnAcknowledgeAlarmsIsLoading={setBtnAcknowledgeAlarmsIsLoading} btnAcknowledgeAlarmsIsLoading={btnAcknowledgeAlarmsIsLoading} />
        <MyRichModal open={openCommentOt} setOpen={setOpenCommentOt} title="Commentaire de l'ot" selectedOt={selectedOt} />
        <DisplayReturnCommand titre="Réponse à la commande" open={openResponseCommand} setOpen={setOpenResponseCommand} text={responseCommand} />
        <DisplayReturnCommand titre="Traces des échanges" open={openLogCommand} setOpen={setOpenLogCommand} text={logCommand} />

      </div>
    );
  } else {
    return (
      <Modal open={true} onClose={(event, reason) => handleOnClose(reason)} style={{ display: 'flex' }}
             disableEscapeKeyDown={true}>
        <div className="modal-detail-equipment">

          {
            equipment &&
            <div className="row-center">
              <div style={{ width: '75%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                <SvgIcon color={'#89a63a'} name={'signal-stream'} size={'100px'} type={equipment.famille}
                         style={{ marginLeft: '15px' }} />
                <span className="title-detail-equipment">{equipment.idSociete ? equipment.idSociete : ''}</span>
                <span className="subtitle-detail-equipment">{equipment.toponyme ? `(${equipment.toponyme})` : ''}</span>
              </div>
              <div style={{ width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <MyButton
                  className="classic-button btn-default color-fond-vert"
                  type="button"
                  labelImportant="Fermer"
                  href="#"
                  iconLeft={{ icon: faTimes, type: 'fontAwesome' }}
                  onClick={handleOnClose}
                />
              </div>
            </div>
          }

          {
            !equipment &&
            <div className="row-center">
              <div style={{ width: '75%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }} />
              <div style={{ width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <MyButton
                  className="classic-button btn-default color-fond-vert"
                  type="button"
                  labelImportant="Fermer"
                  href="#"
                  iconLeft={{ icon: faTimes, type: 'fontAwesome' }}
                  onClick={handleOnClose}
                />
              </div>
            </div>
          }

          {
            equipment && <div className="row">

              <AppBar position="static" className={classes.appBarDesktop}>
                <Tabs value={value} onChange={handleChange}
                      TabIndicatorProps={{ style: { background: '#bb0060', height: '4px' } }}>
                  <Tab className={classes.tabDesktop} label="Détail" {...a11yProps(0)} />
                  <Tab className={classes.tabDesktop} label="Commandes" {...a11yProps(1)}
                       disabled={equipment.pilotable ? false : true} />
                  <Tab className={classes.tabDesktop} label="Histo. des alarmes" {...a11yProps(2)} />
                  <Tab className={classes.tabDesktop} label="Histo. des OT" {...a11yProps(3)} />
                </Tabs>
              </AppBar>

              <OngletDetail
                width={width}
                value={value}
                equipment={equipment}
                urlLogMivisu={`/equipements/${equipment.id}/mivisu/log`}
                auth={auth}
                classes={classes}
                setNeedUpdate={setNeedUpdate}
                handleOpenCommentOt={handleOpenCommentOt}
                handleCreateOt={handleCreateOt}
                setAcknowledgeAllAlarms={setAcknowledgeAllAlarms}
                acknowledgeAllAlarms={acknowledgeAllAlarms}
                btnDownloadMivisuLogIsLoading={btnDownloadMivisuLogIsLoading}
                handleDownloadLogMivisu={handleDownloadLogMivisu}
                generateCardOt={generateCardOt}
                generateCardAlarmes={generateCardAlarmes}
                wsStatus={props.wsStatus}
              />

              {
                equipment.pilotable &&
                <OngletCommandes
                  value={value}
                  width={width}
                  classes={classes}
                  auth={auth}
                  setSelectedCommand={setSelectedCommand}
                  entryCommand={entryCommand}
                  setEntryCommand={setEntryCommand}
                  commandesReferences={commandesReferences}
                  handleSendCommande={handleSendCommande}
                  btnSendCommandeIsLoading={btnSendCommandeIsLoading}
                  handleOpenLogCommand={handleOpenLogCommand}
                  commandes={commandes}
                  wsStatus={props.wsStatus}
                />
              }

              <OngletAlarme
                width={width}
                value={value}
                equipment={equipment}
                classes={classes}
                etats={etats}
                auth={auth}
              />

              <OngletOt
                width={width}
                classes={classes}
                value={value}
                ots={ots}
                handleOpenCommentOt={handleOpenCommentOt}
                generateCardOt={generateCardOt}
                auth={auth}
                wsStatus={props.wsStatus}
              />

            </div>
          }

          {
            !equipment && !props.wsStatus &&
            <div className="row-center" style={{ height: '100%' }}>
              <h2>L'affichage de l'équipement n'est pas possible car aucune donnée en cache n'a été trouvée</h2>
            </div>
          }

          {
            !equipment && props.wsStatus &&
            <div className="row-center" style={{ height: '100%' }}>
              <ClipLoader
                color="#0094ca"
                loading={true}
                css={'display: flex; position: absolute; top: 45%; left:0; right:0; margin:auto; z-index:150; justify-content: center;'}
                size={50}
              />
            </div>
          }

          <SelectMotifAcquittement open={acknowledgeAllAlarms} setOpen={setAcknowledgeAllAlarms} entity={equipment}
                                   setNeedUpdate={setNeedUpdate}
                                   wsStatus={props.wsStatus}
                                   setBtnAcknowledgeAlarmsIsLoading={setBtnAcknowledgeAlarmsIsLoading}
                                   btnAcknowledgeAlarmsIsLoading={btnAcknowledgeAlarmsIsLoading} />
          <MyRichModal open={openCommentOt} setOpen={setOpenCommentOt} title="Commentaire de l'ot"
                       selectedOt={selectedOt} />
          <DisplayReturnCommand titre="Traces des échanges" open={openLogCommand} setOpen={setOpenLogCommand}
                                text={logCommand} />

        </div>
      </Modal>
    );
  }

};

export default EquipmentDetail;